import { NavLink } from 'react-router-dom';
import styles from './NavBar.module.css';

function NavBar() {
  return (
    <nav className={styles.nav}>
           <ul>
            <li><NavLink to="/">Home</NavLink></li>
            <li><NavLink to="/charities">Charities</NavLink></li>
            <li><NavLink to="/gallery">Gallery</NavLink></li>
            <li><NavLink to="/events">Events</NavLink></li>
           </ul> 
    </nav>)
}

export default NavBar;
